import getConfig from 'next/config';
import NextImage, { ImageLoaderProps } from 'next/image';

import { NextImageProps } from '@/components/next-image';

import { buildQueryString } from '@/utils/query-utils';

const { assetPrefix } = getConfig().publicRuntimeConfig;
type AssetImageProps = Omit<NextImageProps, 'loader'>;

export default function AssetImage({ src, ...props }: AssetImageProps) {
  if (props.unoptimized) {
    src = assetPrefix + src.toString().replace(/^\//, '');
  }

  return (
    <NextImage
      {...props}
      src={src}
      loader={assetImageLoader}
      style={{
        maxWidth: '100%',
        height: 'auto',
      }}
    />
  );
}

export function assetImageLoader({ src, width, quality }: ImageLoaderProps) {
  const query = buildQueryString({
    w: width,
    q: quality || 75,
    url: src,
  });

  return assetPrefix + '_next/image?' + query;
}
